var map = {
	"./automated-message.png": "5c85",
	"./heavy-tool.png": "77df",
	"./logistic.png": "03cc",
	"./officer.png": "36c6",
	"./organization.png": "6b54",
	"./shelter.png": "c613"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0006";